// The elements that own the keyboard while focused: a caret is in them, so a
// keystroke is text, not a command. Mirrors Base UI's own typeable selector.
const TEXT_EDITING_SELECTOR =
  "input:not([type='hidden']):not([disabled])," +
  "[contenteditable]:not([contenteditable='false'])," +
  "textarea:not([disabled])";

export function isTextEditingTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.matches(TEXT_EDITING_SELECTOR);
}
